import { Container, Text, Title } from "@mantine/core";

import { ErrorMessage } from "../models/ErrorMessage.ts";
import classes from "../styles/pages/ErrorPage.module.scss";

export const ErrorPage = (errorMessage: ErrorMessage) => {
  return (
    <Container className={classes.root}>
      <Text className={classes.label}>{errorMessage.code}</Text>
      <Title className={classes.title}>{errorMessage.title}</Title>
      <Text className={classes.description}>{errorMessage.description}</Text>
    </Container>
  );
};
